(() => {
  const initializeAccordions = (root = document) => {
    root.querySelectorAll('.accordion, .accordionelite').forEach((button, index) => {
      if (button.dataset.owfAccordionReady === 'true') return;

      const panel = button.nextElementSibling;
      if (!panel) return;

      button.dataset.owfAccordionReady = 'true';
      button.type = 'button';
      button.setAttribute('aria-expanded', 'false');

      if (!panel.id) {
        panel.id = `OwfAccordionPanel-${index}-${Math.random().toString(36).slice(2, 8)}`;
      }
      button.setAttribute('aria-controls', panel.id);

      button.addEventListener('click', () => {
        const isOpen = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!isOpen));
        button.classList.toggle('is-open', !isOpen);
        panel.classList.toggle('is-open', !isOpen);
      });
    });
  };

  class OwfCountdown extends HTMLElement {
    connectedCallback() {
      if (this.dataset.owfCountdownReady === 'true') return;
      this.dataset.owfCountdownReady = 'true';

      this.deadline = new Date(this.dataset.deadline).getTime();
      if (Number.isNaN(this.deadline)) {
        this.hidden = true;
        return;
      }

      this.update();
      this.timer = window.setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      if (this.timer) window.clearInterval(this.timer);
    }

    update() {
      const remaining = this.deadline - Date.now();
      const time = this.querySelector('[data-countdown-time]');
      const closed = this.querySelector('[data-countdown-closed]');

      if (remaining <= 0) {
        if (this.timer) window.clearInterval(this.timer);
        if (time) time.hidden = true;
        if (closed) closed.hidden = false;
        return;
      }

      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);

      this.setValue('[data-countdown-days]', days);
      this.setValue('[data-countdown-hours]', hours);
      this.setValue('[data-countdown-minutes]', minutes);
      this.setValue('[data-countdown-seconds]', seconds);
    }

    setValue(selector, value) {
      const element = this.querySelector(selector);
      if (element) element.textContent = String(value).padStart(2, '0');
    }
  }

  if (!customElements.get('owf-countdown')) {
    customElements.define('owf-countdown', OwfCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAccordions());
  } else {
    initializeAccordions();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAccordions(event.target));
})();
